// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Button_wrapper__1pHwk","confirmationWrapper":"Button_confirmationWrapper__3d9u5","confirmButtons":"Button_confirmButtons__AboaQ","submit":"Button_submit__Hs5ma"};